import { __decorate } from "tslib";
import fetchFromCache from '@/utilities/fetchFromCache';
import { Module, VuexModule, MutationAction } from 'vuex-module-decorators';
let Archetypes = class Archetypes extends VuexModule {
    constructor() {
        super(...arguments);
        this.archetypes = [];
        this.cachedVersion = 0;
    }
    async fetchArchetypes() {
        const { data: archetypes, cachedVersion } = await fetchFromCache(this, 'archetypes', 'archetype');
        return { archetypes, cachedVersion };
    }
};
__decorate([
    MutationAction({ mutate: ['archetypes', 'cachedVersion'] })
], Archetypes.prototype, "fetchArchetypes", null);
Archetypes = __decorate([
    Module({ namespaced: true, name: 'archetypes' })
], Archetypes);
export default Archetypes;
